module.exports = __webpack_public_path__ + "img/12.a48f0c71.svg";